import { Event, Router, NavigationEnd } from '@angular/router';
import { ComparisonService } from './../comparison/comparison.service';
import { QuestionSpecification as qs } from './../../models/client-questions';
import { CustomAnswerModel } from './../../models/comparison/comparison-answers';
import { ZohoAction } from './../../models/enums';
import { Subscription } from 'rxjs';
import { Injectable } from '@angular/core';
import { AnswerService } from './answer.service';
import { ComparisonAnswers } from '../../models/comparison/comparison-answers';
import { debounceTime } from 'rxjs/operators';

@Injectable()
export class ZohoServise {
    private answerChangeSubscription$: Subscription;
    private needEmitQuotesCompleate = true;
    private actionCompleating: { [key: number]: boolean } = {};

    constructor(private answerService: AnswerService, private comparisonService: ComparisonService, private router: Router) {
        this.answerChangeSubscription$ = this.answerChangeSubscribe();
    }

    private answerChangeSubscribe(): Subscription {
        return this.answerService.changeAnswerSetModelEvent().pipe(debounceTime(500)).subscribe((answer: ComparisonAnswers) => {
            this._setPersonalInfo(answer.profileAnswers[0]);
            this._verifyPersonalInfoCompleate(answer);
        });
    }

    public sendZohoQuotesCompleate(): void {
        if (this.needEmitQuotesCompleate) {
            this.comparisonService.postAnswerToZoho(this.answerService.answerSetModel, ZohoAction.QuotesCompleate, this._gclid())
                .subscribe({
                    complete: () => this.needEmitQuotesCompleate = false
                });
        }
    }

    private _verifyPersonalInfoCompleate(answers: ComparisonAnswers): void {
        const currentAnswerCount = answers.profileAnswers[0] ? answers.profileAnswers[0].length : 0;

        if (this.actionCompleating[qs.PersonalFirstName] && this.actionCompleating[qs.PersonalLastName] &&
            this.actionCompleating[qs.PersonalEmail] && this.actionCompleating[qs.PersonalPhoneNumber] &&
            this.actionCompleating[qs.PersonalBirthday] &&
            currentAnswerCount > 4 && this.answerService.answerSetModel.typeId) {
            this.answerChangeSubscription$.unsubscribe();
            this.comparisonService.postAnswerToZoho(answers, ZohoAction.PersonalInfoCompleate, this._gclid())
                .subscribe();
        }
    }

    private _gclid(): string {
        return this._getCookie('gclid');
    }

    private _getCookie(name: string) {
        const ca: Array<string> = document.cookie.split(';');
        const caLen: number = ca.length;
        const cookieName = `${name}=`;
        let c: string;

        for (let i = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) === 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
    }

    private _setPersonalInfo(personlaAnswers: CustomAnswerModel[]): void {
        if (!Array.isArray(personlaAnswers)) {
            return;
        }
        for (const answer of personlaAnswers) {
            switch (answer.specification) {
                case qs.PersonalFirstName: this.actionCompleating[qs.PersonalFirstName] = !!answer.text; break;
                case qs.PersonalLastName: this.actionCompleating[qs.PersonalLastName] = !!answer.text; break;
                case qs.PersonalEmail: this.actionCompleating[qs.PersonalEmail] = !!answer.text; break;
                case qs.PersonalPhoneNumber: this.actionCompleating[qs.PersonalPhoneNumber] = !!answer.text; break;
                case qs.PersonalBirthday: this.actionCompleating[qs.PersonalBirthday] = !!answer.date; break;
                case qs.Personal_Gender: this.actionCompleating[qs.Personal_Gender] = !!answer.date; break;
                case qs.Personal_Occupation: this.actionCompleating[qs.Personal_Occupation] = !!answer.date; break;
            }
        }
    }
}
